import { render, staticRenderFns } from "./SendMailModal.vue?vue&type=template&id=7c65ff37&scoped=true&"
import script from "./SendMailModal.vue?vue&type=script&lang=js&"
export * from "./SendMailModal.vue?vue&type=script&lang=js&"
import style0 from "./SendMailModal.vue?vue&type=style&index=0&id=7c65ff37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c65ff37",
  null
  
)

export default component.exports